/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit OnboardingDots/view.blocks to change it.
import React from 'react'
import sourcePng from "./source.png"
import styles from './view.module.css'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function OnboardingDots({
  children,
  viewPath = "/DesignSystem/Images/OnboardingDots",
  alignSelf = "auto",
  backgroundColor = "transparent",
  borderBottomLeftRadius = 0,
  borderBottomRightRadius = 0,
  borderTopLeftRadius = 0,
  borderTopRightRadius = 0,
  height = 266,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  marginTop = 0,
  source = sourcePng,
  width = 73
  
}) {
  return (<React.Fragment
>
<img
  data-testid="OnboardingDots.Image"
  data-view-path={viewPath}
 alt={""}
 src={source}
 style={{'--as-1-1yQ4zn': alignSelf,'--bc-2-1yQ4zn': backgroundColor,'--bblr-3-1yQ4zn': typeof borderBottomLeftRadius === 'number' ? `${borderBottomLeftRadius}px` : borderBottomLeftRadius,'--bbrr-4-1yQ4zn': typeof borderBottomRightRadius === 'number' ? `${borderBottomRightRadius}px` : borderBottomRightRadius,'--btlr-5-1yQ4zn': typeof borderTopLeftRadius === 'number' ? `${borderTopLeftRadius}px` : borderTopLeftRadius,'--btrr-6-1yQ4zn': typeof borderTopRightRadius === 'number' ? `${borderTopRightRadius}px` : borderTopRightRadius,'--h-7-1yQ4zn': typeof height === 'number' ? `${height}px` : height,'--mb-8-1yQ4zn': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-9-1yQ4zn': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-10-1yQ4zn': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--mt-11-1yQ4zn': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--w-12-1yQ4zn': typeof width === 'number' ? `${width}px` : width}}
 className={`views-block ${styles.Image}`}
/>
{children}
</React.Fragment>)
}